export const isHeicMedia = (file: {
  mimeType?: string;
  contentType?: string;
  name?: string;
  originalFileName?: string;
  fullPath?: string;
  mediaHref?: string;
}) =>
  [file.mimeType, file.contentType].some((type) =>
    /^image\/hei[cf](?:-sequence)?(?:;|$)/i.test(type ?? "")
  ) ||
  [file.name, file.originalFileName, file.fullPath, file.mediaHref].some((name) =>
    /\.hei[cf](?:$|[?#])/i.test(name ?? "")
  );
